export default __webpack_public_path__ + "static/butter-banner-57ebb026789bfd66d0584648275e587c.webp";